const buttonModalLinks = document.querySelectorAll('[data-modal-content]');
const videoModalLinks = document.querySelectorAll('[data-video-src]');


document.getElementById('global-modal').addEventListener('hidden.bs.modal', () => {
    document.getElementById('globalModalBody').innerHTML = '';
});

document.getElementById('global-modal-video-only').addEventListener('hidden.bs.modal', () => {
    document.getElementById('globalVideoModalBody').innerHTML = '';
});

Array.from(buttonModalLinks).forEach((link) => {
    link.addEventListener('click', (e) => {
        e.preventDefault();
        let content = "<div class='content-wrapper'>" + decodeURIComponent(e.target.dataset.modalContent) + " " + decodeURIComponent(e.target.dataset.modalScript) + "</div>";
        openModal(content, false);
    })
});

Array.from(videoModalLinks).forEach((link) => {
    link.addEventListener('click', (e) => {
        e.preventDefault();
        let content = "<div class='video-wrapper'><iframe width='100%' id='video-content-iframe' height='100%' src='" + decodeURIComponent(e.target.dataset.videoSrc) + "' title='YouTube video player' frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe></div>"
        openModal(content, true);
    })
});

const openModal = (content, videoBoolean) => {
    const globalModal = new window.bootstrap.Modal(document.getElementById(videoBoolean ? 'global-modal-video-only' : 'global-modal'));
    setInnerHTML(document.getElementById(videoBoolean ? 'globalVideoModalBody' : 'globalModalBody'), content);
    globalModal.show();
}

const setInnerHTML = function (elm, html) {
    elm.innerHTML = html;
    Array.from(elm.querySelectorAll("script")).forEach(oldScript => {
        const newScript = document.createElement("script");
        Array.from(oldScript.attributes)
            .forEach(attr => newScript.setAttribute(attr.name, attr.value));
        newScript.appendChild(document.createTextNode(oldScript.innerHTML));
        oldScript.parentNode.replaceChild(newScript, oldScript);
    });
}


